// Portal/kiosk adapter. Standalone SCADA players do not import this module.
import { defineAsyncComponent, type App } from 'vue';
import { canvasHostKey } from './canvas-host';
import { useTheme } from './useTheme';
import SynEmbed from './SynEmbed.vue';
import AlarmBanner from './AlarmBanner.vue';

export function installPlatformCanvasHost(app: App) {
  app.provide(canvasHostKey, {
    theme: useTheme(), embed: SynEmbed, alarm: AlarmBanner,
    map: defineAsyncComponent(() => import('./SynMap.vue')),
    chart: defineAsyncComponent(() => import('./SynChart.vue')),
  });
  return app;
}
